import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FavoriteHomeSVG = function FavoriteHomeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27.29 11.4L17.2 1.9a2 2 0 00-2.4 0L4.71 11.4A2 2 0 004 12.93V28a2 2 0 002 2h20a2 2 0 002-2V12.93a2 2 0 00-.71-1.53zm-7 7.6L16 23.3 11.69 19a2.3 2.3 0 01-.69-1.66 2.33 2.33 0 01.69-1.66 2.38 2.38 0 013.33 0l1 1 1-1a2.37 2.37 0 013.33 0 2.33 2.33 0 01.65 1.66 2.3 2.3 0 01-.69 1.66z"
  }));
};
FavoriteHomeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FavoriteHomeSVG);